export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./general.vue?vue&type=template&id=a8ad388a"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/general.vue?vue&type=template&id=a8ad388a
// module id = t/BJ
// module chunks = 0